import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '../../../../global/interfaces/address';
import { AddressFunctions } from '../../../../utils/address.functions';

@Pipe({
  name: 'address',
})
export class AddressPipe implements PipeTransform {
  transform(address: Address | any, format: string = 'full'): any {
    return new AddressFunctions().addressToString(address, format);
  }
}
